import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getFdTypeSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getFdType, params)
    yield put(actions.getFdTypeSuccess(response?.data?.data))
    yield put(actions.getFdTypeFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getFdTypeFinish())
  }
}

function* addFdTypeSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addFdType, body)
    yield put(actions.addFdTypeSuccess(response.data?.data))
    yield delay(100)
    yield put(actions.addFdTypeFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addFdTypeFinish())
  }
}

function* updateFdTypeSaga(action: ActionModel) {
  try {
    const body: any = action.payload.data
    const response: ResponseModel = yield call(service.updateFdType, body, action.payload?.id)
    yield put(actions.updateFdTypeSuccess(response.data?.data))
    yield put(actions.updateFdTypeFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateFdTypeFinish())
  }
}

function* deleteFdTypeSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteFdType, body)
    yield put(actions.deleteFdTypeSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteFdTypeFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteFdTypeFinish())
  }
}

function* singleActivateFdType(action: ActionModel) {
  try {
    const selectedOperationIncharge: any = action.payload
    const response: ResponseModel = yield call(
      service.singleActivateFdType,
      selectedOperationIncharge
    )
    yield put({
      type: actionTypes.SINGLE_ACTIVATE_FD_TYPE_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SINGLE_ACTIVATE_FD_TYPE_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_ACTIVATE_FD_TYPE_FINISH})
  }
}

function* singleDeactivateFdType(action: ActionModel) {
  try {
    const selectedOperationIncharge: any = action.payload
    const response: ResponseModel = yield call(
      service.singleDeactivateFdType,
      selectedOperationIncharge
    )

    yield put({
      type: actionTypes.SINGLE_DEACTIVATE_FD_TYPE_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SINGLE_DEACTIVATE_FD_TYPE_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_DEACTIVATE_FD_TYPE_FINISH})
  }
}

function* sortFdType(action: any) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.sortFdType, body)

    yield put({
      type: actionTypes.SORT_FD_TYPE_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SORT_FD_TYPE_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SORT_FD_TYPE_FINISH})
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_FD_TYPE_START, getFdTypeSaga)
  yield takeLatest(actionTypes.ADD_FD_TYPE_START, addFdTypeSaga)
  yield takeLatest(actionTypes.UPDATE_FD_TYPE_START, updateFdTypeSaga)
  yield takeLatest(actionTypes.DELETE_FD_TYPE_START, deleteFdTypeSaga)
  yield takeLatest(actionTypes.SINGLE_ACTIVATE_FD_TYPE_REQUEST, singleActivateFdType)
  yield takeLatest(actionTypes.SINGLE_DEACTIVATE_FD_TYPE_REQUEST, singleDeactivateFdType)
  yield takeLatest(actionTypes.SORT_FD_TYPE_START, sortFdType)
}
